"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ZoomContainer = styled_components_1.default.div `
    -moz-transform: ${props => `scale(${props.$zoom / 100})`};
    -moz-transform-origin: 0 0;
    zoom: ${props => (props.$zoom ? `${props.$zoom}%` : '100%')};
    width: ${props => (props.$zoom ? `${props.$zoom}%` : '100%')};

    transition: all 0.02s;

    *:not(p, h1, h2, h3) {
        transition: all 0.02s;
    }
`;
